import { BehaviorSubject } from 'rxjs';
import { DEFAULT_E_BIKE_SPEED, DEFAULT_E_MOUNTAIN_BIKE_SPEED, DEFAULT_MOUNTAIN_BIKE_SPEED, TourColors, DEFAULT_BIKE_SPEED, } from '../apis/api-tours.js';
export const tourStyleData$ = new BehaviorSubject({
    colorRgb: '#dddddd',
    opacity: 100,
});
export const tours$ = new BehaviorSubject(undefined);
export const currentlyActiveTourType$ = new BehaviorSubject(undefined);
export const activeTrackId$ = new BehaviorSubject(undefined);
export const activeTrackPoisCount$ = new BehaviorSubject(0);
export const currentlyActiveTourBikeSpeed$ = new BehaviorSubject(undefined);
export const currentlyActiveTourEBikeSpeed$ = new BehaviorSubject(undefined);
export const currentlyActiveTourMountainBikeSpeed$ = new BehaviorSubject(undefined);
export const currentlyActiveTourEMountainBikeSpeed$ = new BehaviorSubject(undefined);
export const currentlyActiveTourHikeSpeed$ = new BehaviorSubject(undefined);
export const currentlyActiveTourWinterhikeSpeed$ = new BehaviorSubject(undefined);
export const currentlyActiveTourSnowshoeSpeed$ = new BehaviorSubject(undefined);
export const gpxExportInProgress$ = new BehaviorSubject(false);
export const tourSettingsShown$ = new BehaviorSubject(true);
export const disableFactsCalculation$ = new BehaviorSubject(false);
import { userSettings$ } from './store-user.js';
export function resolveBikeSpeed() {
    return determineSpeed(DEFAULT_BIKE_SPEED, userSettings$.getValue()?.bicycleSpeed, currentlyActiveTourBikeSpeed$.getValue());
}
export function resolveEBikeSpeed() {
    return determineSpeed(DEFAULT_E_BIKE_SPEED, userSettings$.getValue()?.eBicycleSpeed, currentlyActiveTourEBikeSpeed$.getValue());
}
export function resolveMountainBikeSpeed() {
    return determineSpeed(DEFAULT_MOUNTAIN_BIKE_SPEED, userSettings$.getValue()?.mountainBikingSpeed, currentlyActiveTourMountainBikeSpeed$.getValue());
}
export function resolveEMountainBikeSpeed() {
    return determineSpeed(DEFAULT_E_MOUNTAIN_BIKE_SPEED, userSettings$.getValue()?.eMountainBikingSpeed, currentlyActiveTourEMountainBikeSpeed$.getValue());
}
export function resolveHikeSpeed() {
    return determineSpeed(1.0, userSettings$.getValue()?.hikeSpeed, currentlyActiveTourHikeSpeed$.getValue());
}
export function resolveWinterhikeSpeed() {
    return determineSpeed(1.0, userSettings$.getValue()?.winterhikeSpeed, currentlyActiveTourWinterhikeSpeed$.getValue());
}
export function resolveSnowshoeSpeed() {
    return determineSpeed(1.0, userSettings$.getValue()?.snowshoeSpeed, currentlyActiveTourSnowshoeSpeed$.getValue());
}
export function determineSpeed(defaultSpeed, userSettingsSpeed, tourSpeed) {
    return tourSpeed ?? userSettingsSpeed ?? defaultSpeed;
}
export function createEmptyTour(userSettings) {
    const pref = {
        color: userSettings.color,
        colorRgb: TourColors[userSettings.color],
        gpspoints: userSettings.gpsPoints,
        opacity: userSettings.opacity,
        timetype: userSettings.timetype || 'wander',
        bikespeed: userSettings.bicycleSpeed || DEFAULT_BIKE_SPEED,
        ebikespeed: userSettings.eBicycleSpeed || DEFAULT_E_BIKE_SPEED,
        hikespeed: userSettings.hikeSpeed || 1,
        winterhikespeed: userSettings.winterhikeSpeed || 1,
        snowshoespeed: userSettings.snowshoeSpeed || 1,
        mountainbikespeed: userSettings.mountainBikingSpeed || DEFAULT_MOUNTAIN_BIKE_SPEED,
        emountainbikespeed: userSettings.eMountainBikingSpeed || DEFAULT_E_MOUNTAIN_BIKE_SPEED,
    };
    const newTour = {
        properties: {
            name: '',
            type: 'normal',
            public: false,
            meta: {
                elemin: 0,
                elemax: 0,
                length: 0,
                totalup: 0,
                totaldown: 0,
                walking: 0,
                biking: 0,
                winterHiking: 0,
                snowshoeTrekking: 0,
            },
            pref: pref,
            filter: null,
            userdate: new Date().toISOString().split('T')[0],
        },
        geom: [[]],
        pois: [],
        viapointsIndices: [[]],
        surfacesIndices: [],
    };
    return newTour;
}
//# sourceMappingURL=store-tours.js.map